module.exports = __webpack_public_path__ + "img/101-04.prt.025b5e60.jpg";